import {Link, Text} from 'src/v2/components/common';
import {COLORS} from 'src/v2/util/color';

type LinkButtonProps = Parameters<typeof Link>[0];

export const LinkButton = ({children, ...props}: LinkButtonProps) => {
  return (
    <Link type="secondary" {...props}>
      <Text type="body" css={{color: COLORS.textPrimary}}>
        {children}
      </Text>
    </Link>
  );
};
